import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import RestoreIcon from '@mui/icons-material/Restore';

interface ResetConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dashboardName?: string;
}

const ResetConfirmationDialog: React.FC<ResetConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  dashboardName = 'dashboard',
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ pb: 1 }}>Reset Dashboard Layout</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
          <RestoreIcon color='primary' sx={{ mr: 2, mt: 0.5 }} />
          <Box>
            <Typography variant='body1'>
              Are you sure you want to reset the layout for "{dashboardName}"?
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
              This will restore all widgets to their original positions and
              sizes.
            </Typography>
          </Box>
        </Box>

        <Paper
          elevation={0}
          sx={{
            mt: 2,
            p: 2,
            bgcolor: 'rgba(245, 124, 0, 0.1)',
            borderRadius: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
            <WarningAmberIcon color='warning' sx={{ mr: 1, mt: 0.5 }} />
            <Box>
              <Typography
                variant='body1'
                color='warning.dark'
                fontWeight='bold'
              >
                Warning:
              </Typography>
              <Typography variant='body2' color='warning.main'>
                Your current dashboard layout will be permanently lost. This
                action cannot be undone.
              </Typography>
            </Box>
          </Box>
        </Paper>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color='primary' variant='outlined'>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color='error'
          variant='contained'
          startIcon={<RestoreIcon />}
          autoFocus
        >
          Reset Layout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ResetConfirmationDialog);
